// extracted by mini-css-extract-plugin
module.exports = {"button":"GhostDownloadButton_button__-3Lwl","button__text":"GhostDownloadButton_button__text__lwHGU"};